import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-weigh",
  "use": "icon-weigh-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"icon-weigh\">\r\n<path d=\"M64,76.7c7,0,12.7-5.7,12.7-12.7v-2.5l24.2-24.2L92,28.4L67.8,52.5c-1.3-1.3-2.5-1.3-3.8-1.3c-7,0-12.7,5.7-12.7,12.7\r\n\tS57,76.7,64,76.7z\" />\r\n<path d=\"M79.3,22c-5.1-1.9-10.2-2.5-15.3-2.5c-8.9,0-17.2,2.5-24.8,7.6c-7,4.5-12.7,11.5-16.5,19.7c-3.2,8.3-4.5,17.2-2.5,25.5\r\n\tc1.9,8.9,5.7,16.5,12.1,22.9l8.9-8.9c-4.5-4.5-7.6-10.3-8.9-16.5c-1.3-6.4-0.6-12.7,1.9-18.5c2.5-5.7,6.4-10.8,11.5-14\r\n\tc5.7-3.2,12.1-5.1,18.5-5.1c1.9,0,3.2,0,5.1,0.6L79.3,22L79.3,22z M95.8,60.2c0.6,3.2,0,7-0.6,10.2c-1.3,6.4-4.5,12.1-8.9,16.5\r\n\tl8.9,8.9c6.4-6.4,10.2-14,12.1-22.9c1.3-7.6,1.3-15.9-1.3-22.9L95.8,60.2z\" />\r\n<path d=\"M64,0.4C29,0.4,0.4,29,0.4,64S29,127.6,64,127.6S127.6,99,127.6,64S99,0.4,64,0.4z M64,114.9C36,114.9,13.1,92,13.1,64\r\n\tS36,13.1,64,13.1S114.9,36,114.9,64S92,114.9,64,114.9z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/weigh.svg
// module id = hofw
// module chunks = 217